import { OptionItem } from '@js/common/types/OptionItem'

import { InputValidation } from '@f/elements/FormText/ValidationUtils'

import { Domain } from '@f-fertighaus/applications/Next/pages/house-detail-page/HDPContent'

import { POSTAL_CODE_LENGTH_BY_COUNTRY, validationMessage } from './validation'

export const INVALID_PHONE_ERROR_MESSAGE =
  'Bitte geben Sie Ihre richtige Handynummer an. Einige Anbieter senden die gewünschten Informationen nur an Interessenten mit vollständig korrekten Kontaktdaten. Danke!'

export const CONSTANTS = {
  construction_method: [
    {
      value: '1',
      label: 'Fertighaus',
      description:
        'Individuelle Häuser aus Holz. Profitieren Sie von einem schnellen Hausaufbau und großer Planungssicherheit.'
    },
    {
      value: '2',
      label: 'Massivhaus',
      description:
        'An Ort und Stelle gebaute Häuser aus Stein. Von Grund auf massive Bauweise und robustes Mauerwerk.'
    },
    {
      value: '3',
      label: 'Blockhaus'
    }
  ],
  construction_start: [
    {
      value: 'as_soon_as_possible',
      label: 'Ab sofort'
    },
    {
      value: 'within_1_year',
      label: 'Innerhalb 1 Jahres'
    },
    {
      value: 'within_1_to_2_years',
      label: 'In 1 - 2 Jahren'
    },
    {
      value: 'in_more_than_2_years',
      label: 'In mehr als 2 Jahren'
    }
  ],
  energy_standard: [
    {
      value: '8',
      label: '3 Liter Haus'
    },
    {
      value: '4',
      label: 'Effizienzhaus 40'
    },
    {
      value: '7',
      label: 'Effizienzhaus 40+'
    },
    {
      value: '9',
      label: 'Effizienzhaus 40 EE'
    },
    {
      value: '10',
      label: 'Effizienzhaus 40 NH'
    },
    {
      value: '3',
      label: 'Effizienzhaus 55'
    },
    {
      value: '5',
      label: 'Passivhaus'
    },
    {
      value: '6',
      label: 'Plusenergiehaus'
    },
    {
      value: '1',
      label: 'Niedrigenergiehaus'
    }
  ],
  expansion_stage: [
    {
      value: 'keyready',
      label: 'Schlüsselfertig',
      price: {
        perSquareMeter: {
          min: 1800,
          typical: 2300
        },
        absolute: { min: 150000, max: 600000 }
      },
      description:
        'Den Hausauf- und Innenausbau übernimmt der Anbieter, sodass das Haus direkt bezogen werden kann.'
    },
    {
      value: 'fitting',
      label: 'Ausbauhaus',
      price: {
        perSquareMeter: { min: 1000, typical: 1500 },
        absolute: { min: 100000, max: 600000 }
      },
      description:
        'Das Haus ist aufgebaut und verfügt über eine Außenhülle mit gedämmten Wänden, Türen und Fenstern. Der Innenausbau erfolgt in Eigenleistung.'
    },
    {
      value: 'lego',
      label: 'Bausatzhaus',
      price: {
        perSquareMeter: { min: 1000, typical: 1500 },
        absolute: { min: 100000, max: 600000 }
      },
      description:
        'Der Anbieter liefert das Haus als Bausatz. Für den Auf- und Ausbau ist der Bauherr größtenteils selbst verantwortlich, wird aber bei Bedarf durch den Anbieter fachlich unterstützt.'
    },
    {
      value: 'unknown',
      label: 'Weiß nicht',
      price: {
        perSquareMeter: {
          min: 1800,
          typical: 2300
        },
        absolute: { min: 150000, max: 600000 }
      },
      description: ''
    }
  ],
  house_style: [
    {
      value: '2',
      label: 'Modern'
    },
    {
      value: '1',
      label: 'Klassisch'
    },
    {
      value: '3',
      label: 'Bauhaus'
    },
    {
      value: '5',
      label: 'Landhaus'
    },
    {
      value: '4',
      label: 'Mediterran'
    },
    {
      value: '9',
      label: 'Skandinavisch'
    },
    {
      value: '8',
      label: 'Amerikanisch'
    },
    {
      value: '6',
      label: 'Alpenländisch'
    },
    {
      value: '7',
      label: 'Nordisch'
    },
    {
      value: '11',
      label: 'Design'
    }
  ],
  house_type: [
    {
      value: '1',
      label: 'Bungalows'
    },
    {
      value: '5',
      label: 'Kubushäuser'
    },
    {
      value: '4',
      label: 'Stadtvillen'
    },
    {
      value: '7',
      label: 'Fachwerkhäuser'
    },
    {
      value: '3',
      label: 'Blockhäuser'
    },
    {
      value: '6',
      label: 'Pultdachhaus'
    },
    {
      value: '2',
      label: 'Satteldachklassiker'
    }
  ],
  utilization: [
    {
      value: '1',
      label: 'Einfamilienhaus'
    },
    {
      value: '2',
      label: 'Doppelhaus'
    },
    {
      value: '4',
      label: 'Mehrfamilienhaus'
    },
    {
      value: '5',
      label: 'Zweifamilienhaus'
    }
  ],
  house_purpose: [
    {
      value: 'eigennutzung',
      label: 'Eigennutzung',
      description:
        'Du möchtest selbst einziehen. Die richtige Baufinanzierung ist für dich dann besonders wichtig.'
    },
    {
      value: 'kapitalanlage',
      label: 'Kapitalanlage',
      description:
        'Das Objekt ist für dich eine Investition, dann ist eine gute Rendite für dich besonders wichtig.'
    },
    {
      value: 'teilweise',
      label: 'Teilweise vermietet',
      description:
        'Du möchtest die Immobilie zunächst vermieten - das kann Steuervorteile haben.'
    }
  ],
  property: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'reserved',
      label: 'Reserviert'
    },
    {
      value: 'expected',
      label: 'In Aussicht'
    },
    {
      value: 'no',
      label: 'Nein'
    }
  ],
  roof_shape: [
    {
      value: '1',
      label: 'Satteldach'
    },
    {
      value: '2',
      label: 'Walmdach'
    },
    {
      value: '3',
      label: 'Flachdach'
    },
    {
      value: '4',
      label: 'Pultdach'
    },
    {
      value: '5',
      label: 'Zeltdach'
    },
    {
      value: '7',
      label: 'Mansarddach'
    },
    {
      value: '8',
      label: 'Krüppelwalmdach'
    },
    {
      value: '12',
      label: 'Runddach'
    }
  ],
  marital_status: [
    {
      value: 'single',
      label: 'Ledig'
    },
    {
      value: 'married',
      label: 'Verheiratet'
    },
    {
      value: 'divorced',
      label: 'Geschieden'
    },
    {
      value: 'living_separately',
      label: 'Getrennt lebend'
    },
    {
      value: 'widowed',
      label: 'Verwittwet'
    },
    {
      value: 'other',
      label: 'Sonstiges'
    }
  ],
  number_of_kids: [
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4_or_more', label: '4 oder mehr' }
  ],
  occupation: [
    { value: 'employee', label: 'Angestellter' },
    { value: 'independent', label: 'Selbstständig' },
    { value: 'official', label: 'Beamter' },
    { value: 'retired', label: 'In Rente' },
    { value: 'student', label: 'Student' },
    { value: 'unemployed', label: 'Erwerbslos' }
  ],
  house_buyer_stage: [
    { value: 'inspiration', label: 'Suche nach Inspiration' },
    { value: 'information', label: 'Informiere mich zum Ablauf' },
    { value: 'comparison', label: 'Bewerte potenzielle Anbieter' },
    { value: 'offers', label: 'Vergleiche Preisangebote' }
  ]
}

export const PROPERTIES: Record<string, { value: string; label: string }[]> = {
  budget_range: [
    { value: '< 100.000', label: 'Weniger als 100.000 €' },
    { value: '100.000 - 150.000', label: '100.000 - 150.000 €' },
    { value: '150.000 - 200.000', label: '150.000 - 200.000 €' },
    { value: '200.000 - 250.000', label: '200.000 - 250.000 €' },
    { value: '250.000 - 300.000', label: '250.000 - 300.000 €' },
    { value: '300.000 - 350.000', label: '300.000 - 350.000 €' },
    { value: '350.000 - 400.000', label: '350.000 - 400.000 €' },
    { value: '400.000 - 450.000', label: '400.000 - 450.000 €' },
    { value: '450.000 - 500.000', label: '450.000 - 500.000 €' },
    { value: '500.000 - 550.000', label: '500.000 - 550.000 €' },
    { value: '550.000 - 600.000', label: '550.000 - 600.000 €' },
    { value: '> 600.000', label: 'Mehr als 600.000 €' },
    { value: 'na', label: 'Keine Angabe' }
  ],
  living_area_total: [
    { value: '< 75', label: 'Weniger als 75 m²' },
    { value: '75 - 100', label: '75 - 100 m²' },
    { value: '100 - 120', label: '100 - 120 m²' },
    { value: '120 - 140', label: '120 - 140 m²' },
    { value: '140 - 160', label: '140 - 160 m²' },
    { value: '160 - 180', label: '160 - 180 m²' },
    { value: '180 - 200', label: '180 - 200 m²' },
    { value: '200 - 225', label: '200 - 225 m²' },
    { value: '225 - 250', label: '225 - 250 m²' },
    { value: '250 - 275', label: '250 - 275 m²' },
    { value: '275 - 300', label: '275 - 300 m²' },
    { value: '> 300', label: 'Mehr als 300 m²' },
    { value: 'na', label: 'Keine Angabe' }
  ],

  property: [
    { value: 'yes', label: 'Ja' },
    { value: 'reserved', label: 'Reserviert' },
    { value: 'expected', label: 'In Aussicht' },
    { value: 'no', label: 'Nein' }
  ],

  construction_start: [
    { value: 'as_soon_as_possible', label: 'So schnell wie möglich' },
    { value: 'within_1_year', label: 'Innerhalb eines Jahres' },
    { value: 'within_1_to_2_years', label: 'In 1-2 Jahren' },
    { value: 'in_more_than_2_years', label: 'In mehr als 2 Jahren' }
  ],

  construction_method: [
    { value: 'prefab', label: 'Fertighaus' },
    { value: 'solid', label: 'Massivhaus' },
    { value: 'blockhouse', label: 'Blockhaus' }
  ],

  house_style: [
    { value: 'classic', label: 'Klassisch' },
    { value: 'modern', label: 'Modern' },
    { value: 'bauhaus', label: 'Bauhaus' },
    { value: 'mediterranean', label: 'Mediterran' },
    { value: 'country_house', label: 'Landhaus' },
    { value: 'alpine', label: 'Alpenländisch' },
    { value: 'nordic', label: 'Nordisch' },
    { value: 'american', label: 'Amerikanisch' },
    { value: 'scandinavian', label: 'Skandinavisch' },
    { value: 'individualised', label: 'Individuell' },
    { value: 'designer', label: 'Design' }
  ],

  roof_shape: [
    { value: 'saddle_roof', label: 'Satteldach' },
    { value: 'hipped_roof', label: 'Walmdach' },
    { value: 'flat_roof', label: 'Flachdach' },
    { value: 'pent_roof', label: 'Pultdach' },
    { value: 'tent_roof', label: 'Zeltdach' },
    { value: 'half_hipped_roof', label: 'Krüppelwalmdach' },
    { value: 'mansard_roof', label: 'Mansardendach' },
    { value: 'round_roof', label: 'Runddach' }
  ],

  house_type: [
    { value: 'bungalow', label: 'Bungalow' },
    { value: 'classic_gabled_roof', label: 'Satteldach-Klassiker' },
    { value: 'block_house', label: 'Blockhaus' },
    { value: 'city_villa', label: 'Stadtvilla' },
    { value: 'cube_house', label: 'Cubushaus' },
    { value: 'pent_roof_house', label: 'Pultdachhaus' },
    { value: 'timber_frame_house', label: 'Fachwerk' }
  ],

  utilization: [
    { value: 'detached_house', label: 'Einfamilienhaus' },
    { value: 'duplex', label: 'Doppelhaus' },
    { value: 'two_families_house', label: 'Zweifamilienhaus' },
    { value: 'apartment_house', label: 'Mehrfamilienhaus' }
  ],

  expansion_stage: [
    { value: 'price_ready', label: 'Schlüsselfertig' },
    { value: 'price_fitting', label: 'Ausbauhaus' },
    { value: 'price_lego', label: 'Bausatzhaus' }
  ],

  energy_standard: [
    { value: 'kfw_55', label: 'Effizienzhaus 55' },
    { value: 'kfw_40', label: 'Effizienzhaus 40' },
    { value: 'positive_energy_house', label: 'Plusenergiehaus' },
    { value: 'kfw_40_plus', label: 'Effizienzhaus 40 Plus' },
    { value: 'kfw_40_ee', label: 'Effizienzhaus 40 EE' },
    { value: 'kfw_40_nh', label: 'Effizienzhaus 40 NH' },
    { value: 'kfw_55_ee', label: 'Effizienzhaus 55 EE' },
    { value: 'kfw_55_nh', label: 'Effizienzhaus 55 NH' }
  ],

  special_criteria_eco_house: [
    { value: 'yes', label: 'Ja' },
    { value: 'no', label: 'Nein' }
  ],

  special_criteria_allergy: [
    { value: 'yes', label: 'Ja' },
    { value: 'no', label: 'Nein' }
  ],

  special_criteria_barrier_free: [
    { value: 'yes', label: 'Ja' },
    { value: 'no', label: 'Nein' }
  ]
}

export const SEARCH_PROPERTIES: { [index: string]: any } = {
  construction_method: {
    name: 'construction_method',
    values: [
      { key: 'prefab', value: '1' },
      { key: 'solid', value: '2' },
      { key: 'blockhouse', value: '3' }
    ]
  },

  house_style: {
    name: 'styles',
    values: [
      { key: 'classic', value: '1' },
      { key: 'modern', value: '2' },
      { key: 'bauhaus', value: '3' },
      { key: 'mediterranean', value: '4' },
      { key: 'country_house', value: '5' },
      { key: 'alpine', value: '6' },
      { key: 'nordic', value: '7' },
      { key: 'american', value: '8' },
      { key: 'scandinavian', value: '9' },
      { key: 'individualised', value: '10' },
      { key: 'designer', value: '11' }
    ]
  },

  roof_shape: {
    name: 'roof_shape',
    values: [
      { key: 'saddle_roof', value: '1' },
      { key: 'hipped_roof', value: '2' },
      { key: 'flat_roof', value: '3' },
      { key: 'pent_roof', value: '4' },
      { key: 'tent_roof', value: '5' },
      { key: 'half_hipped_roof', value: '7' },
      { key: 'mansard_roof', value: '8' },
      { key: 'round_roof', value: '12' }
    ]
  },

  house_type: {
    name: 'form',
    values: [
      { key: 'bungalow', value: '1' },
      { key: 'classic_gabled_roof', value: '2' },
      { key: 'block_house', value: '3' },
      { key: 'city_villa', value: '4' },
      { key: 'cube_house', value: '5' },
      { key: 'pent_roof_house', value: '6' },
      { key: 'timber_frame_house', value: '7' }
    ]
  },

  utilization: {
    name: 'utilization',
    values: [
      { key: 'detached_house', value: '1' },
      { key: 'duplex', value: '2' },
      { key: 'two_families_house', value: '4' },
      { key: 'apartment_house', value: '5' }
    ]
  },

  energy_standard: {
    name: 'energy_standard',
    values: [
      { key: 'kfw_55', value: '3' },
      { key: 'kfw_40', value: '4' },
      { key: 'positive_energy_house', value: '6' },
      { key: 'kfw_40_plus', value: '7' },
      { key: 'kfw_40_ee', value: '9' },
      { key: 'kfw_40_nh', value: '10' },
      { key: 'kfw_55_ee', value: '11' },
      { key: 'kfw_55_nh', value: '12' }
    ]
  },

  special_criteria_eco_house: {
    name: 'target_groups',
    value: '8'
  },

  special_criteria_allergy: {
    name: 'target_groups',
    value: '4'
  },

  special_criteria_barrier_free: {
    name: 'target_groups',
    value: '7'
  }
}

export const TRACKING_MAPPING: { [index: string]: any } = {
  additional_request_comment: {
    label: 'additional-request-comment'
  },
  construction_method: { label: 'construction-method' },
  construction_start: { label: 'construction-start' },
  contact_preference: { label: 'contact-preference' },
  'cookie-es': { label: 'cookie' },
  'cookie-st': { label: 'cookie' },
  'cookie-fu': { label: 'cookie' },
  'cookie-ma': { label: 'cookie' },
  energy_standards: { label: 'energy-standard' },
  expansion_stage: { label: 'expansion-stage' },
  expected_value: { label: 'expected-value' },
  financing_needed: { label: 'financing-needed' },
  financing_volume: { label: 'loan-amount' },
  financing_consultation_interest: { label: 'financing-consultation-interest' },
  finance_wizard_planned_use: { label: 'house-purpose' },
  financing_handover_consent: { label: 'financing-consent' },
  first_name: { label: 'first-name' },
  house_purpose: { label: 'house-purpose' },
  house_type: { label: 'house-type' },
  keywords: { isTrackingAllowed: true },
  last_name: { label: 'last-name' },
  living_area_total: { label: 'living-area-total' },
  loan_amount: { label: 'loan-amount' },
  marital_status: { label: 'marital-status' },
  monthly_income: { label: 'monthly-income' },
  new_password: { label: 'new-password' },
  number_of_kids: { label: 'number-kids' },
  postal_code: { label: 'postal-code' },
  receive_newsletter: { label: 'newsletter' },
  roof_shape: { label: 'roof-shape' },
  target_groups: { label: 'target-group' },
  title: { label: 'title' },
  text: { label: 'text' },
  rating: { label: 'rating', isTrackingAllowed: true },
  userStage: { label: 'user-stage', isTrackingAllowed: true },
  contactPerson: { label: 'contact-person', isTrackingAllowed: true },
  experienceCity: { label: 'experience-city', isTrackingAllowed: true },
  experiencePostalCode: {
    label: 'experience-postal-code',
    isTrackingAllowed: true
  }
}

export const GENDER_RADIO_INPUT_VALUES = [
  {
    value: 'm',
    label: 'Herr',
    inputProps: { 'data-sel': 'btn-male' }
  },
  {
    value: 'f',
    label: 'Frau',
    inputProps: { 'data-sel': 'btn-female' }
  }
]

export const COUNTRY_SELECT_INPUT_VALUES: OptionItem<string>[] = [
  { value: 'DE', label: 'Deutschland', isDefault: true },
  { value: 'AT', label: 'Österreich' },
  { value: 'CH', label: 'Schweiz' },
  { value: 'IT', label: 'Italien' },
  { value: 'N/A', label: 'Anderes Land' }
] as const

export const RESTRICTED_NAME_LAST_NAME_COMBINATIONS: Record<string, string> = {
  max: 'mustermann',
  hans: 'wurst',
  arsch: 'loch',
  peter: 'pan'
}

export type InputValidationType =
  | 'street'
  | 'postal_code'
  | 'city'
  | 'first_name'
  | 'last_name'
  | 'email'
  | 'phone'
  | 'gender'
  | 'country'

export const INPUT_VALIDATION: Record<
  InputValidationType,
  InputValidation[]
> = {
  street: [
    {
      rule: 'not-empty',
      message: 'Bitte Straße und Hausnummer angeben.'
    },
    {
      rule: 'street',
      message: 'Bitte zusätzlich zur Straße auch Ihre Hausnummer angeben.'
    }
  ],
  postal_code: [
    {
      rule: 'not-empty',
      message: 'Bitte PLZ angeben.'
    },
    {
      rule: 'postal-code',
      message: 'Bitte PLZ angeben.'
    },
    {
      rule: 'not-matches-another-input',
      message: 'Ungültige Postleitzahl für dieses Land.',
      linkedFieldName: 'country',
      invalidIf: (postalCode, country) => {
        return Boolean(
          POSTAL_CODE_LENGTH_BY_COUNTRY[country] &&
            POSTAL_CODE_LENGTH_BY_COUNTRY[country] !== postalCode.length
        )
      }
    }
  ],
  city: [
    {
      rule: 'not-empty',
      message: 'Bitte Stadt angeben.'
    },
    {
      rule: 'city',
      message: 'Ungültige Eingabe.'
    }
  ],
  phone: [
    {
      rule: 'not-empty',
      message: validationMessage.phone.required
    },
    {
      rule: 'number-api-check',
      message:
        'Bitte geben Sie Ihre richtige Handynummer an. Einige Anbieter senden die gewünschten Informationen nur an Interessenten mit vollständig korrekten Kontaktdaten. Danke!'
    }
  ],
  first_name: [
    {
      rule: 'not-empty',
      message: validationMessage.firstName.required
    },
    {
      rule: 'at-least-two-characters-long',
      message: validationMessage.firstName.tooShort
    },
    {
      rule: 'first-name',
      message: validationMessage.firstName.inappropriate
    },
    {
      rule: 'not-matches-another-input',
      message: validationMessage.firstName.inappropriate,
      linkedFieldName: 'last_name',
      invalidIf: (name, lastName) => {
        const nameLowerCase = name?.toLowerCase() || ''
        const lastNameLowerCase = lastName?.toLowerCase() || ''

        return (
          nameLowerCase === lastNameLowerCase ||
          Boolean(
            RESTRICTED_NAME_LAST_NAME_COMBINATIONS[nameLowerCase] ===
              lastNameLowerCase
          )
        )
      }
    }
  ],
  last_name: [
    {
      rule: 'not-empty',
      message: validationMessage.lastName.required
    },
    {
      rule: 'at-least-two-characters-long',
      message: validationMessage.lastName.tooShort
    },
    {
      rule: 'last-name',
      message: validationMessage.lastName.inappropriate
    },
    {
      rule: 'not-matches-another-input',
      message: validationMessage.lastName.inappropriate,
      linkedFieldName: 'first_name',
      invalidIf: (lastName, name) => {
        const nameLowerCase = name?.toLowerCase() || ''
        const lastNameLowerCase = lastName?.toLowerCase() || ''

        return (
          nameLowerCase === lastNameLowerCase ||
          Boolean(
            RESTRICTED_NAME_LAST_NAME_COMBINATIONS[nameLowerCase] ===
              lastNameLowerCase
          )
        )
      }
    }
  ],
  email: [
    {
      rule: 'not-empty',
      message: validationMessage.email.required
    },
    {
      rule: 'e-mail',
      message: validationMessage.email.valid
    }
  ],
  gender: [
    {
      rule: 'not-empty',
      message: validationMessage.gender.required
    }
  ],
  country: [
    {
      rule: 'not-empty',
      message: validationMessage.postalCode.countryNoMatch
    }
  ]
}

export const SQUARE_METER_PRICE_HOUSE_WITH_NO_PRICE = 3000

export const DOMAINS_WITH_USER_ACCOUNT: Domain[] = [
  'fertighaus',
  'massivhaus',
  'einfamilienhaus',
  'bungalow',
  'bauen'
]

export const LOCATION_TYPES = [
  {
    name: 'house_vendor',
    label: 'Zentrale'
  },
  {
    name: 'sales_profile',
    label: 'Beratungsbüro'
  },
  {
    name: 'model_house',
    label: 'Musterhaus'
  }
]
